import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'
import FaFileArchiveO from 'react-icons/lib/fa/file-archive-o'
import autobind from 'autobind-decorator'
import baseURL from '../../../../../Root/url'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'

@withMutation(gql`
  mutation requestAuthenticationToken {
    token: requestAuthenticationToken {
      _id
      userId
      expiry
    }
  }
`)
@withMessage
export default class Title extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    verifyDocument: PropTypes.object,
    requestAuthenticationToken: PropTypes.func
  }

  state = {}

  @autobind
  async request() {
    this.setState({loading: true})
    try {
      const {token} = await this.props.requestAuthenticationToken()
      window.location.href = `${baseURL}/contracts/pdf/${this.props.verifyDocument._id}/${
        token._id
      }`
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  renderDownload(){

    console.log("=======> renderDownload")
    console.log(JSON.stringify(this.props.verifyDocument));
    console.log(JSON.stringify(this.props.verifyDocument.documentStatus));

    if (this.props.verifyDocument.documentStatus.status === 'ready') {
      
      return(
            <div className={styles.Button}>
              <div className={styles.downloadButton}>
                <Button primary onClick={this.request} loading={this.state.loading}>
                  Descargar
                </Button>
              </div>
            </div>
      )
    } else {
      return(
        <div className={styles.Button}>
              <div className={styles.downloadButton}>
                <Button primary>
                  No completado
                </Button>
              </div>
        </div>
      )
          
    }
      
  }

  render() {
    if (!this.props.verifyDocument) return
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-3">
              <div className="row">
                <div className={styles.IconTrailing}>
                  <FaFileArchiveO size={'25'} />
                </div>
                <div className={styles.Title}>
                  <h3>Documento:</h3>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6">
              <div className={styles.Name}>
                <h3>{this.props.verifyDocument.name}</h3>
              </div>
            </div>
              <div className="col-xs-12 col-sm-3 end-md">{this.renderDownload()}</div>
            
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/DocumentVerify/Main/Verify/Title/index.js